"use strict";
/**
 * Created by Ning Jiang on 10/31/2017.
 * Moved from WildNudge by Ning Jiang on 5/17/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NudgeReelEvent = void 0;
class NudgeReelEvent {
}
NudgeReelEvent.NUDGE_STEP_START = "nudgeReelEvent_nudgeStepStart";
NudgeReelEvent.NUDGE_STEP_COMPLETED = "nudgeReelEvent_nudgeStepCompleted";
NudgeReelEvent.NUDGE_COMPLETED = "nudgeReelEvent_nudgeCompleted";
exports.NudgeReelEvent = NudgeReelEvent;
//# sourceMappingURL=NudgeReelEvent.js.map